import RichTextEditor, {
  EditorValue,
  ToolbarConfig,
} from 'src/lib/rich-text-editor';

type Props = {
  value: EditorValue;
  onChange: (value: EditorValue) => void;
  disabled?: boolean;
};

const EditorBox = ({ value, onChange, disabled }: Props) => {
  const toolbarConfig = {
    display: [
      'INLINE_STYLE_BUTTONS',
      'BLOCK_TYPE_BUTTONS',
      'BLOCK_TYPE_DROPDOWN',
      'HISTORY_BUTTONS',
    ],
    INLINE_STYLE_BUTTONS: [
      {
        label: 'B',
        style: 'BOLD',
        className: 'custom-css-class',
      },
      { label: 'I', style: 'ITALIC' },
      { label: 'U', style: 'UNDERLINE' },
    ],
    BLOCK_TYPE_DROPDOWN: [
      { label: 'Normal', style: 'unstyled' },
      { label: 'Heading Large', style: 'header-one' },
      { label: 'Heading Medium', style: 'header-two' },
      { label: 'Heading Small', style: 'header-three' },
    ],
    BLOCK_TYPE_BUTTONS: [
      { label: 'UL', style: 'unordered-list-item' },
      { label: 'OL', style: 'ordered-list-item' },
    ],
    BLOCK_ALIGNMENT_BUTTONS: [],
  } satisfies ToolbarConfig;
  return (
    <RichTextEditor
      className="editor-box editor-box--framed"
      toolbarConfig={toolbarConfig}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  );
};

export default EditorBox;
